import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AlertManagerService {
  private suppressNextAlert = false;

  /** Chame este método antes de fazer uma requisição HTTP
   * quando você quer tratar com o erro no componente de forma personalizada
   */
  suppressNextErrorAlert() {
    this.suppressNextAlert = true;
  }

  /** Usado pelo interceptor para verificar se deve mostrar alertas */
  shouldShowAlert() {
    if (this.suppressNextAlert) {
      this.suppressNextAlert = false;
      return false;
    }
    return true;
  }

  /** Reseta o flag de supressão, caso necessário */
  resetSuppression() {
    this.suppressNextAlert = false;
  }
}